import { Field } from "react-final-form";
import FilesContainer from "component/filesContainer/FilesContainer";
import { PickerVehicleDataFilesType } from "pages/pickers/types";
import {
  FILTER_PICKERS_OPTIONS,
  VALIDATION_REGEX,
  VEHICLE_MOTORIZED_DOCUMENT_NAMES,
  VEHICLE_MOTORIZED_DOCUMENT_TAGS,
  VEHICLE_TAGS,
} from "utils/constants";
import { VehicleDataProps } from "../types";
import "../../detailPicker.scss";
import { useTranslation } from "react-i18next";
import "../i18n";
import {
  InformativeNotification,
  SelectInput,
  SimpleDateInput,
  TextInput,
} from "@pickit/pickit-components";

const VehicleDataCL = ({
  isMotorized,
  showMotorizedFileReplaceReminder,
  testId,
  isActivePicker,
  pickerId,
  ...props
}: VehicleDataProps) => {
  const { t } = useTranslation("vehicle");
  return (
    <div
      data-testId={testId}
      id={testId}
      className="container-detail-picker-fluid card-container"
    >
      <div className="container-detail-picker-row">
        <div className="container-detail-picker-col-xs-24 container-detail-picker-col-sm-8 container-detail-picker-col-xl-6 ">
          <Field
            name="vehicle.type"
            label={t("typeLabel")}
            testId={`${testId}-vehicle`}
            id={`${testId}-vehicle`}
            options={FILTER_PICKERS_OPTIONS.map((o) => ({
              ...o,
              id: o.value,
              name: t(o.label),
            }))}
            showClearIcon={false}
          >
            {(propsField: any) => (
              <SelectInput {...propsField} overlayPosition="bottom" />
            )}
          </Field>
        </div>
        {isMotorized && (
          <>
            <div className="container-detail-picker-col-xs-24 container-detail-picker-col-sm-8 container-detail-picker-col-xl-6 ">
              <Field
                type="text"
                testId={testId + "-patent"}
                id={testId + "-patent"}
                name="vehicle.patent"
                label={t("patentLabel")}
                component={TextInput}
                className="Admin-Pickers-input"
                placeholder={t("patentPlaceholder")}
                maxLength={
                  props.vehicleType === VEHICLE_TAGS["4_WHEELS"] ? 6 : 5
                }
                pattern={VALIDATION_REGEX.lettersAndNumbers}
              />
            </div>
            <div className="container-detail-picker-col-xs-24 container-detail-picker-col-sm-8 container-detail-picker-col-xl-6">
              <Field
                type="text"
                testId={testId + "-driver-license"}
                id={testId + "-driver-license"}
                name="vehicle.expirationDateDriverLicense"
                label={t("licenseExpirationLabel")}
                component={SimpleDateInput}
                dateType="fullDate"
                className="Admin-Pickers-input"
                placeholder={t("global:date")}
              />
            </div>
            <div className="container-detail-picker-col-xs-24 container-detail-picker-col-sm-8 container-detail-picker-col-xl-6 ">
              <Field
                type="text"
                testId={testId + "-identification"}
                id={testId + "-identification"}
                name="vehicle.expirationDateIdentificationVehicle"
                label={t("identifierExpirationLabel")}
                component={SimpleDateInput}
                dateType="fullDate"
                className="Admin-Pickers-input"
                placeholder={t("global:date")}
              />
            </div>
            <div className="container-detail-picker-col-xs-24 container-detail-picker-col-sm-8 container-detail-picker-col-xl-6">
              <Field
                type="text"
                testId={testId + "-policy"}
                id={testId + "-policy"}
                name="vehicle.expirationDatePolicyVehicle"
                label={t("carInsuranceExpirationLabel")}
                component={SimpleDateInput}
                dateType="fullDate"
                className="Admin-Pickers-input"
                placeholder={t("global:date")}
              />
            </div>
          </>
        )}
      </div>
      <div className="container-detail-picker-row">
        {isMotorized && showMotorizedFileReplaceReminder && (
          <div className="margin-bottom-24 container-detail-picker-col-xs-24 container-detail-picker-col-sm-12 container-detail-picker-col-xl-12">
            <InformativeNotification
              dataTestId={`${testId}-motorized-files-reminder`}
              title={t("motorizedFilesReminderTitle")}
              body={t("motorizedFilesReminderBody")}
              showClearIcon={false}
              status="warning"
            />
          </div>
        )}
      </div>
      {isMotorized && (
        <FilesContainer<PickerVehicleDataFilesType>
          testId={testId + "-files"}
          id={testId + "-files"}
          {...props}
          showDeleteIcon={!isActivePicker}
          names={VEHICLE_MOTORIZED_DOCUMENT_NAMES}
          fileUploadScopeKey={pickerId}
          slotTagsInOrder={
            isMotorized ? [...VEHICLE_MOTORIZED_DOCUMENT_TAGS] : undefined
          }
        />
      )}
    </div>
  );
};

export default VehicleDataCL;
